import React, { createContext, useReducer } from "react";
import Cookies from "universal-cookie";
import Reducer from "./Reducer";

const cookies = new Cookies();
const cookieSCStation = cookies.get("scStation");

export const clearStationState = {
  accounts: [],

  boxEvents: [],
  boxSettings: [],
  controlBoxes: [],

  currentPressure: [],
  currentVitals: [],
  scStation: null,
  scStationError: null,

  patientSnToBox: {},
  dashboardView: null, // { tab, sortBy, viewStyle, searchFilter }
  patientTransfer: null,
  boxConfigurations: null,
  networkProfiles: null,
  networkProfilesById: null,
};

export const clearUserAndStationState = {
  ...clearStationState,
  loginUserId: null, // Also known as "AccountName" or the user field on login.
  user: null,
  userName: null,
  userTokenError: null,
  role: null,
  permissions: [], // set directly from cognito:groups at login
  scStations: [],
};

export const initialState = {
  vars: null,
  varsError: null,
  cancelSubscriptions: false,
  scStation: cookieSCStation,
  ...clearUserAndStationState,
};

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);

  return (
    <StoreContext.Provider value={[state, dispatch]}>
      {children}
    </StoreContext.Provider>
  );
};

export const StoreContext = createContext(initialState);
export default Store;
